import React, { useState, useContext, useMemo } from "react";
import Style from "../InkData.module.css";

import {electionInterface} from '../InkData';
import {InkItemDataContext,InkEventDataContext} from '../../../WebSocket/WebSocket';

import IconButton from '@mui/material/IconButton';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import {cloneDeep} from 'lodash';
import { useTranslation } from 'react-i18next';

import DataBox from './DataBox';
import DataModal, {clickDataInterface} from './ModalData';

export default function Events({election}:{election:electionInterface}){
	const [clickDataModal, setClickDataModal] = useState<clickDataInterface>({
    open: false,
    index: 0,
    deviceIndex: 0,
    checked: false
	});

	const ws = useContext(InkItemDataContext);
	const inkDataItem = ws[election.deviceIndex];
	const event = useContext(InkEventDataContext);
  const inkDataEvent = event.inkEventData[election.deviceIndex];
  const { i18n, t } = useTranslation();


  return(
		<table>
      <thead>
        <tr className={Style.tableHader}>
          <th>Index</th>
          <th>{t("icon")}</th>
          <th>{t("title")}</th>
          <th>{t("value")}</th>
          <th>{t("time-stamp")}</th>
          <th>
            <IconButton>
              <MoreHorizIcon />
            </IconButton>
          </th>
        </tr>
      </thead>
      <tbody>
				{inkDataEvent.map(({web_id,value,time},index) => {
					let data = cloneDeep(inkDataItem[web_id]);
					data.value.value = value;
          data.value.time = time;
          

					return(
            <React.Fragment key={index} >
              <DataBox setClickDataModal={setClickDataModal} election={election} data={data} />
            </React.Fragment>
					); 
				})}
      </tbody>
			{clickDataModal.open ? <DataModal dataModal={clickDataModal} setModal={setClickDataModal} /> : ""}
    </table>
  );
}

